Directives.projectParticipants = function projectParticipants() {

    // @ngInject
    function ProjectParticipantsDirectiveControllerFunc($scope, $injector, ModalService, WorkspacesManager, DeviceService, OnboardingBotManager) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ProjectParticipantsDirectiveControllerFunc';

        this.ModalService = ModalService;
        this.WorkspacesManager = WorkspacesManager;
        this.DeviceService = DeviceService;
        this.OnboardingBotManager = OnboardingBotManager;

        this.workspace.on('success', this.loadModels, this);
        this.isLoading = true;
        this.onboardingBotActive = false;
        this.isMobile = this.DeviceService.checkIfMobileSize();
    }

    var ProjectParticipantsDirectiveController = Class(Controllers.BaseController, {
        constructor: ProjectParticipantsDirectiveControllerFunc,

        loadModels: function loadModels() {
            this.shouldShowDropdownParticipants = false;
            this.fileOwnerId = this.workspace.creator._id;
            this.isLoading = false;
            this.onboardingBotActive = this.OnboardingBotManager.isOnboardingBotActiveOnWS(this.workspace);

            this.workspaceParticipants = this.getParticipants();

            if(this.isMobile) {
                this.limitVisibleParticipants(1);
            } else {
                this.limitVisibleParticipants(3);
                this.setHelperText();
            }
        },

        getParticipants: function getParticipants() {
             return this.workspace.members
                .map(function (participant) {
                    return {
                        index: this.prepareParticipantIndex(participant),
                        participant: participant
                    };
                }.bind(this))

                .sort(function (a, b) {
                    return a.index - b.index;
                }.bind(this));
        },

        limitParticipantsNumber: function limitPatricipantsNumber() {
            return this.isMobile ? 1 : 3;
        },

        limitVisibleParticipants: function limitVisibleParticipants(max) {
            if(this.workspaceParticipants.length > max) {
                this.shouldShowDropdownParticipants = true;
                this.additionalWorkspaceParticipants = this.workspaceParticipants.slice(max);
            }
        },

        setHelperText: function setHelperText() {
            var numOfParticipants = this.workspaceParticipants.length;
            var text = 'Visible to you';

            if(numOfParticipants <= 1) {
                this.workspaceIsVisibleTo = text;

            } else if(numOfParticipants === 2) {
                this.workspaceIsVisibleTo = text + ' + 1 participant';
            }
            else {
                this.workspaceIsVisibleTo = text + ' + ' + (numOfParticipants - 1) + ' participants';
            }
        },

        prepareParticipantIndex: function prepareParticipantIndex(participant) {

            //Current User
            if (participant._id === this.currentUser._id ) {
                return 0;
            }

            //Team Members
            else if ( participant.company._id === this.workspace.company_id  ) {
                return 2;
            }

            //Clients
            else {
                return 1;
            }

        },

        toggleViewAllParticipants: function toggleViewAllParticipants() {
            this.showAllMembersDropDown = !this.showAllMembersDropDown;
        },

        closeViewAllParticipants: function closeViewAllParticipants() {
            this.showAllMembersDropDown = false;
        },

        openParticipantModal: function openParticipantModal(participant) {

            // don't open for me
            if (participant.participant._id === this.currentUser._id ) {
                return;
            }

            // allow edit & remove
            var allowActions =
                this.currentUser.isVendor() &&
                !this.workspace.isViewOnlyMode() &&
                !this.workspace.isArchived();

            this.ModalService.openWorkspaceParticipantModal(participant.participant, this.workspace, allowActions);
        },

        openAddParticipantModal: function openAddParticipantModal() {
            this.ModalService.openAddWorkspaceParticipantModal(this.workspace).then(function editSuccess(resp) {
                this.workspace.members.push(resp.user);
                this.loadModels();
                this.WorkspacesManager.reloadWorkspaceInfo(this.workspace._id);
            }.bind(this));
        },

        // uppercaseFirstLetter: function uppercaseFirstLetter(elem) {
        //     if(elem){
        //         return elem.charAt(0).toUpperCase() + elem.substr(1).toLowerCase();
        //     }
        // }

    });

    return {
        scope: {
            workspace: '=',
            currentUser: '<'
        },
        templateUrl: 'angular/app/modules/core/features/workspace/project_participants/project_participants.html',
        controller: ProjectParticipantsDirectiveController,
        controllerAs: 'projectParticipantsVm',
        bindToController: true
    };
};
